import React, { Fragment } from "react";
import { Link, Redirect } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { resetPassword } from "../../actions/auth";

//components
// import BreadCrumb from "../../components/breadcrumb/breadcrumb";

import Alert from "../../components/alert/alert.component";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      password: "",
      token: "",
      confirmPassword: "",
      message: "",
      class: "",
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const token = window.location.toString().split("t/")[1];

    if (token) {
      this.setState({ token: token });
    }
  }
  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    if (this.state.confirmPassword === this.state.password) {
      if (this.state.password && this.state.token) {
        const data = {
          password: this.state.password,
          token: this.state.token,
        };

        const res = await this.props.resetPassword(data);
        if (res) {
          this.setState({
            message: "Your Password Has Been Changed",
            class: "alert-success",
          });
        }
      }
    } else {
      this.setState({
        message: "Confirm Passwod didn't match",
        class: "alert-danger",
      });
    }

    // const res = await this.props.auth();

    // if (localStorage.getItem("checkout") === true) {
    //   this.props.history.push("/checkout");
    // }

    // if (!res) {
    //   this.setState({ loading: false });
    // }
  };

  render() {
    const { isAuth } = this.props._auth;
    return !isAuth && !this.props._auth.loading ? (
      <Fragment>
        <div className="create-an-account">
          <div className="regester-top">
            <div className="container">
              <div className="row mx-md-5">
                <header className="col-md-12" id="create-acc-header">
                  {/*<strong>
                    <Link
                      className="navbar-brand"
                      to="/"
                      id="logo"
                      title="sundialhomeproducts.com"
                    >
                      Sundial
                    </Link>
                  </strong>*/}
                  <span className="secure-login">
                    Reset Password <i className="fa fa-lock" />
                  </span>
                </header>
              </div>
            </div>
          </div>
          <div className="create-account">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div id="acc-container">
                    <div className="create-acc-heading">
                      <h3>Reset Password</h3>
                    </div>
                    <Alert />
                    {this.state.message && (
                      <div
                        className={`alert ${this.state.class}`}
                        role="alert"
                        style={{
                          width: "100%",
                          marginBottom: "2%",
                          marginTop: "2%",
                          borderRadius: "12px",
                        }}
                      >
                        {this.state.message}
                      </div>
                    )}

                    <form
                      id="registerForm"
                      onSubmit={(e) => {
                        this.onSubmit(e);
                      }}
                    >
                      <div className="create-acc-email">
                        <input
                          className="create-acc-inp"
                          type="password"
                          autoComplete="password"
                          onChange={(e) => {
                            this.setState({ password: e.target.value });
                          }}
                        />
                        <span className="creat-inp-error" />
                        <span className="create-acc-placeholder">
                          {" "}
                          Password
                        </span>
                      </div>
                      <div className="create-acc-email">
                        <input
                          className="create-acc-inp"
                          type="password"
                          autoComplete="confirmPassword"
                          onChange={(e) => {
                            this.setState({ confirmPassword: e.target.value });
                          }}
                        />
                        <span className="creat-inp-error" />
                        <span className="create-acc-placeholder">
                          {" "}
                          Confirm Password
                        </span>
                      </div>
                      <div className="create-acc-btn">
                        <button type="submit" className="create-acc">
                          Reset Password
                        </button>
                      </div>
                      <div className="form-footer">
                        <p className="hav-acc">
                          Don’t have an account?{" "}
                          <Link to={"/register"} id="signIn-acc">
                            Sign Up
                          </Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    ) : null;
  }
}

resetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { resetPassword })(Login);
